
<template>
    <div class="search-autocomplete" v-on:mouseleave="showResults = false"
        v-if="showResults && results.documents && results.documents.length > 0">
        <div class="search-autocomplete__suggestion" @click="runSearch(suggestion.suggestion)"
            v-for="(suggestion, index) in results.documents" :key="index">
            {{ suggestion.suggestion }}
        </div>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    data() {
        return {
            timer: null,
            results: {
                documents: []
            },
            searchInput: null,
            searchQuery: document.querySelector("#search-input").value,
            showResults: false,
        }
    },
    mounted() {
        this.searchInput = document.querySelector("#search-input");
        if (this.searchInput) {
            let self = this;
            document.querySelector("#search-input").addEventListener("input", function (event) {
                clearTimeout(self.timer);
                self.searchQuery = event.target.value;

                self.timer = setTimeout(() => {
                    self.runTrigger()
                }, 100)
            });
            document.querySelector("body").addEventListener("click", function (event) {
                self.showResults = false;
            });
        }
    },
    methods: {
        runSearch(term) {
            this.showResults = false;
            document.querySelector("#search-input").value = term;
            document.querySelector("#search-page").value = "1";
            document.querySelector("#search-form").submit();
        },
        runTrigger() {
            if (this.searchQuery && this.searchQuery.length > 3) {
                axios.post("https://o-melveny-site-search.ent.us-central1.gcp.cloud.es.io/api/as/v1/engines/umbraco-search-production/query_suggestion", {
                    query: this.searchQuery,
                    types: {
                        documents: {
                            fields: [
                                "title",
                                "full_name",
                                "professional_languages",
                                "professional_education",
                                "professional_admissions",
                                "professional_honors",
                                "professional_activities",
                                "professional_corporate_experience",
                            ]
                        }
                    },
                    size: 5
                }, {
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer search-p5qfzquhtw1okw3mibb219ja'
                    }
                })
                    .then((response) => {
                        this.results = response.data.results;
                        this.showResults = true;
                    })
                    .catch((err) => {
                        this.showResults = false;
                    });
            }
        }
    }
}
</script>